import { Component, OnInit, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, NavigationEnd, RouterLinkActive } from '@angular/router';
import { CommonModule } from '@angular/common';
import { TranslocoService, TranslocoModule } from '@jsverse/transloco';
import { Router } from '@angular/router';
import { RouteParamService } from '../../../services/route-param.service';
import { filter } from 'rxjs';
import { MatDialog, MatDialogClose } from '@angular/material/dialog';
import { BookingConfigService } from '../../../services/booking-config.service';
import { AuthService } from '../../../../../app/services/auth.service';
import { MatIcon } from '@angular/material/icon';
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';
import { SnackbarService } from '../../../../../app/services/snackbar.service';
import { StateService } from '../../../../../app/services/state.service';
import { WelcomeComponent } from '../../../components/welcome/welcome.component';
import { MatIconModule } from '@angular/material/icon';
import { CartService } from '../../../../../app/parkifly-bookings/services/cart.service';
import { LoginService } from '../../../../../app/services/login.service';
import { FormService } from '../../features/booking/components/form/service';
import { LoginComponent } from '../../../../../app/pages/login/login.component';
import { Title } from '@angular/platform-browser';
import { ManageBookingModalComponent } from '../../../components/manage-booking-modal/manage-booking-modal.component';

@Component({
  selector: 'organization-top-navbar',
  imports: [WelcomeComponent, RouterLinkActive, CommonModule, TranslocoModule, MatIcon, MatMenu, MatMenuItem, MatMenuTrigger],
  templateUrl: './top-navbar.component.html',
  styleUrl: './top-navbar.component.scss',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  encapsulation: ViewEncapsulation.None
})

export class TopNavbarComponent implements OnInit {
  isLeftNavHidden = true;
  site: string = '';
  tui: boolean = false;
  languageImageSources: { [key: string]: string } = {
    en: "../../../../../assets/img/flag-button-round-250-EN.png",
    sv: "../../../../../assets/img/flag-button-round-250-SV.png",
  };
  languageImageSource: string = '';

  constructor(
    private _translocoService: TranslocoService,
    private route: ActivatedRoute,
    private router: Router,
    private routeParamService: RouteParamService,
    public dialog: MatDialog,
    private bookingConfigService: BookingConfigService,
    public authService: AuthService,
    public snackbarService: SnackbarService,
    public stateService: StateService,
    private cartService: CartService,
    private loginService: LoginService,
    private _formService: FormService,
    private titleService: Title
  ) {
    const config = this.bookingConfigService.getConfig();
    if (this.isCustomerSiteUrl(this.router.url)) {
      this.site = 'default';
    } else {
      this.site = config.site;
    }
  }

  isCustomerSiteUrl(url: string): boolean {
    const u = url ? url.toLowerCase() : '';
    return u.includes('search-results') ||
      u.includes('customer-home') ||
      u.includes('customer-portal') ||
      u.includes('drivein') ||
      u.includes('drive-in-booking') ||
      u.includes('drive-in-details-form') ||
      u.includes('drive-up-booking') ||
      u.includes('drive-up-details-form');
  }

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      if (!this.isCustomerSiteUrl(this.router.url)) {
        this.bookingConfigService.setOrganizationFromUrl();
      }
      let config = this.bookingConfigService.getConfig();
      if (this.isCustomerSiteUrl(this.router.url)) {
        this.site = 'default';
        this.titleService.setTitle('Parkifly');
      } else {
        this.site = config.site;
      }
    });

    this.routeParamService.org$.subscribe((val: any) => {
      this.tui = val.toLowerCase() == 'tui' ? true : false;
    });
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: any) => {
      if (this.isCustomerSiteUrl(this.router.url)) {
        this.site = 'default';
        this.titleService.setTitle('Parkifly');
      }
    });

    let activeLanguage: string = this._translocoService.getActiveLang();

    this.languageImageSource = activeLanguage === 'en' ? this.languageImageSources['sv'] : this.languageImageSources['en'];
  }
  toggleLanguage() {
    let activeLanguage = this._translocoService.getActiveLang();

    if (activeLanguage == 'sv') {
      this._translocoService.setActiveLang('en');

    } else {
      this._translocoService.setActiveLang('sv');
    }
    activeLanguage = this._translocoService.getActiveLang();
    this.languageImageSource = activeLanguage === 'en' ? this.languageImageSources['sv'] : this.languageImageSources['en'];

  }

  toggleLeftNav() {
    this.isLeftNavHidden = !this.isLeftNavHidden;
  }

  goToHomePage() {
    if (this.router.url.includes('/booking')) {
      const dialogRef = this.dialog.open(ConfirmModal);
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this.router.navigate(['/']);
        }
      });
    } else {
      this.router.navigate(['/']);
    }
  }

  async gotToBooking(site: string) {
    const orderId = await this.cartService.getOrderId();
    if (orderId) {
      this.cartService.abortorder(orderId).subscribe({
        next: (result) => {
          this.cartService.setOrderId(null);
        }
      });
    }
    if (site == 'default') {
      this.router.navigate(['/customer-portal']);
    } else if (site == 'flygets') {
      this.router.navigate(['flygets', 'flygets-start']);
    } else if (site == 'quality-xpo-arlanda') {
      this.router.navigate(['parkifly', 'quality-landing-page'], { queryParams: { public: 'true' } });
    } else if (site == 'aiden') {
      this.router.navigate(['parkifly', 'aiden-landing-page'], { queryParams: { public: 'true' } });
    }
    else {
      this.router.navigate(['parkifly', site]);
    }
  }

  goToHandleBooking() {
    this.dialog.open(ManageBookingModalComponent, {
      width: '90%',
      maxWidth: '440px',
      panelClass: 'manage-booking-dialog-panel'
    });
  }

  login() {
    const targetRoute = this.site ? `parkifly/my-orders/${this.site}` : 'parkifly/my-orders/flygets';
    this.dialog.open(LoginComponent, {
      width: '500px',
      disableClose: false,
      panelClass: 'login-dialog-panel',
      data: { forceMobileLayout: true, currentRoute: targetRoute }
    });
  }

  logout() {
    this.stateService.logout().subscribe(() => {
      const message = this._translocoService.translate('LOGIN.LOGOUT');
      this.snackbarService.openSnackBar(message, 'OK');
    });

    if (
      (this.router.url.includes('parkifly') &&
        this.router.url.includes('my-orders') &&
        this.router.url.includes(this.site))
    ) {
      this.router.navigate(['parkifly', this.site]);
    }
    else if ((this.router.url.includes('parkifly-new') &&
      this.router.url.includes('my-orders') &&
      this.router.url.includes(this.site))) {
      this.router.navigate(['parkifly-new', this.site]);
    }

  }

  goToOrders() {
    this.router.navigate(['parkifly/my-orders', this.site]);
  }

}

@Component({
  selector: 'confirm-modal',
  templateUrl: 'confirm-modal.html',
  styleUrl: './confirm-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TranslocoModule, MatDialogClose]
})
export class ConfirmModal {
  constructor() { }
}